export default "__VITE_ASSET__BHekmHLP__"